import 'react-toastify/dist/ReactToastify.css';

import { useEffect } from 'react';
import { toast } from 'react-toastify';

interface ReactNotificationsProps {
  title: string;
  body: string;
}

const ReactNotifications = ({
  title,
  body,
}: ReactNotificationsProps): null => {
  useEffect(() => {
    toast.info(
      <div>
        <h4>{title}</h4>
        <p>{body}</p>
      </div>
    );
  }, [title, body]);

  return null;
};

export default ReactNotifications;
